export interface CityData {
  name: string;
  nameEn: string;
  nameZh: string;
  timezone: string;
  country: string;
  countryCode: string;
  flag: string;
  population?: number;
}

// 主要国家热门城市数据
export const popularCitiesByCountry: Record<string, CityData[]> = {
  CN: [
    { name: '北京', nameEn: 'Beijing', nameZh: '北京', timezone: 'Asia/Shanghai', country: 'China', countryCode: 'CN', flag: '🇨🇳', population: 21540000 },
    { name: '上海', nameEn: 'Shanghai', nameZh: '上海', timezone: 'Asia/Shanghai', country: 'China', countryCode: 'CN', flag: '🇨🇳', population: 24870000 },
    { name: '广州', nameEn: 'Guangzhou', nameZh: '广州', timezone: 'Asia/Shanghai', country: 'China', countryCode: 'CN', flag: '🇨🇳', population: 15300000 },
    { name: '深圳', nameEn: 'Shenzhen', nameZh: '深圳', timezone: 'Asia/Shanghai', country: 'China', countryCode: 'CN', flag: '🇨🇳', population: 12590000 },
    { name: '天津', nameEn: 'Tianjin', nameZh: '天津', timezone: 'Asia/Shanghai', country: 'China', countryCode: 'CN', flag: '🇨🇳', population: 15620000 },
    { name: '重庆', nameEn: 'Chongqing', nameZh: '重庆', timezone: 'Asia/Shanghai', country: 'China', countryCode: 'CN', flag: '🇨🇳', population: 32050000 },
    { name: '苏州', nameEn: 'Suzhou', nameZh: '苏州', timezone: 'Asia/Shanghai', country: 'China', countryCode: 'CN', flag: '🇨🇳', population: 12750000 },
    { name: '成都', nameEn: 'Chengdu', nameZh: '成都', timezone: 'Asia/Shanghai', country: 'China', countryCode: 'CN', flag: '🇨🇳', population: 20940000 },
    { name: '武汉', nameEn: 'Wuhan', nameZh: '武汉', timezone: 'Asia/Shanghai', country: 'China', countryCode: 'CN', flag: '🇨🇳', population: 12330000 },
    { name: '杭州', nameEn: 'Hangzhou', nameZh: '杭州', timezone: 'Asia/Shanghai', country: 'China', countryCode: 'CN', flag: '🇨🇳', population: 11940000 },
    { name: '西安', nameEn: 'Xi\'an', nameZh: '西安', timezone: 'Asia/Shanghai', country: 'China', countryCode: 'CN', flag: '🇨🇳', population: 12950000 },
    { name: '郑州', nameEn: 'Zhengzhou', nameZh: '郑州', timezone: 'Asia/Shanghai', country: 'China', countryCode: 'CN', flag: '🇨🇳', population: 12600000 },
    { name: '南京', nameEn: 'Nanjing', nameZh: '南京', timezone: 'Asia/Shanghai', country: 'China', countryCode: 'CN', flag: '🇨🇳', population: 9320000 },
    { name: '青岛', nameEn: 'Qingdao', nameZh: '青岛', timezone: 'Asia/Shanghai', country: 'China', countryCode: 'CN', flag: '🇨🇳', population: 10070000 },
    { name: '沈阳', nameEn: 'Shenyang', nameZh: '沈阳', timezone: 'Asia/Shanghai', country: 'China', countryCode: 'CN', flag: '🇨🇳', population: 9070000 },
    { name: '东莞', nameEn: 'Dongguan', nameZh: '东莞', timezone: 'Asia/Shanghai', country: 'China', countryCode: 'CN', flag: '🇨🇳', population: 10460000 },
    { name: '大连', nameEn: 'Dalian', nameZh: '大连', timezone: 'Asia/Shanghai', country: 'China', countryCode: 'CN', flag: '🇨🇳', population: 7500000 },
    { name: '厦门', nameEn: 'Xiamen', nameZh: '厦门', timezone: 'Asia/Shanghai', country: 'China', countryCode: 'CN', flag: '🇨🇳', population: 5280000 },
    { name: '佛山', nameEn: 'Foshan', nameZh: '佛山', timezone: 'Asia/Shanghai', country: 'China', countryCode: 'CN', flag: '🇨🇳', population: 9500000 },
    { name: '福州', nameEn: 'Fuzhou', nameZh: '福州', timezone: 'Asia/Shanghai', country: 'China', countryCode: 'CN', flag: '🇨🇳', population: 8290000 },
    { name: '长沙', nameEn: 'Changsha', nameZh: '长沙', timezone: 'Asia/Shanghai', country: 'China', countryCode: 'CN', flag: '🇨🇳', population: 8290000 },
    { name: '济南', nameEn: 'Jinan', nameZh: '济南', timezone: 'Asia/Shanghai', country: 'China', countryCode: 'CN', flag: '🇨🇳', population: 8700000 },
    { name: '哈尔滨', nameEn: 'Harbin', nameZh: '哈尔滨', timezone: 'Asia/Shanghai', country: 'China', countryCode: 'CN', flag: '🇨🇳', population: 10000000 },
    { name: '昆明', nameEn: 'Kunming', nameZh: '昆明', timezone: 'Asia/Shanghai', country: 'China', countryCode: 'CN', flag: '🇨🇳', population: 8500000 },
    { name: '南宁', nameEn: 'Nanning', nameZh: '南宁', timezone: 'Asia/Shanghai', country: 'China', countryCode: 'CN', flag: '🇨🇳', population: 8700000 },
    { name: '合肥', nameEn: 'Hefei', nameZh: '合肥', timezone: 'Asia/Shanghai', country: 'China', countryCode: 'CN', flag: '🇨🇳', population: 9370000 },
    { name: '石家庄', nameEn: 'Shijiazhuang', nameZh: '石家庄', timezone: 'Asia/Shanghai', country: 'China', countryCode: 'CN', flag: '🇨🇳', population: 11000000 },
    { name: '南昌', nameEn: 'Nanchang', nameZh: '南昌', timezone: 'Asia/Shanghai', country: 'China', countryCode: 'CN', flag: '🇨🇳', population: 5500000 },
    { name: '太原', nameEn: 'Taiyuan', nameZh: '太原', timezone: 'Asia/Shanghai', country: 'China', countryCode: 'CN', flag: '🇨🇳', population: 5300000 },
    { name: '贵阳', nameEn: 'Guiyang', nameZh: '贵阳', timezone: 'Asia/Shanghai', country: 'China', countryCode: 'CN', flag: '🇨🇳', population: 5800000 }
  ],
  
  US: [
    { name: 'New York', nameEn: 'New York', nameZh: '纽约', timezone: 'America/New_York', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 8380000 },
    { name: 'Los Angeles', nameEn: 'Los Angeles', nameZh: '洛杉矶', timezone: 'America/Los_Angeles', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 3970000 },
    { name: 'Chicago', nameEn: 'Chicago', nameZh: '芝加哥', timezone: 'America/Chicago', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 2700000 },
    { name: 'Houston', nameEn: 'Houston', nameZh: '休斯顿', timezone: 'America/Chicago', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 2320000 },
    { name: 'Phoenix', nameEn: 'Phoenix', nameZh: '凤凰城', timezone: 'America/Phoenix', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 1680000 },
    { name: 'Philadelphia', nameEn: 'Philadelphia', nameZh: '费城', timezone: 'America/New_York', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 1580000 },
    { name: 'San Antonio', nameEn: 'San Antonio', nameZh: '圣安东尼奥', timezone: 'America/Chicago', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 1530000 },
    { name: 'San Diego', nameEn: 'San Diego', nameZh: '圣地亚哥', timezone: 'America/Los_Angeles', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 1420000 },
    { name: 'Dallas', nameEn: 'Dallas', nameZh: '达拉斯', timezone: 'America/Chicago', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 1340000 },
    { name: 'San Jose', nameEn: 'San Jose', nameZh: '圣何塞', timezone: 'America/Los_Angeles', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 1030000 },
    { name: 'Austin', nameEn: 'Austin', nameZh: '奥斯汀', timezone: 'America/Chicago', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 980000 },
    { name: 'Jacksonville', nameEn: 'Jacksonville', nameZh: '杰克逊维尔', timezone: 'America/New_York', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 950000 },
    { name: 'Fort Worth', nameEn: 'Fort Worth', nameZh: '沃思堡', timezone: 'America/Chicago', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 920000 },
    { name: 'Columbus', nameEn: 'Columbus', nameZh: '哥伦布', timezone: 'America/New_York', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 900000 },
    { name: 'Charlotte', nameEn: 'Charlotte', nameZh: '夏洛特', timezone: 'America/New_York', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 880000 },
    { name: 'San Francisco', nameEn: 'San Francisco', nameZh: '旧金山', timezone: 'America/Los_Angeles', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 875000 },
    { name: 'Indianapolis', nameEn: 'Indianapolis', nameZh: '印第安纳波利斯', timezone: 'America/Indiana/Indianapolis', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 870000 },
    { name: 'Seattle', nameEn: 'Seattle', nameZh: '西雅图', timezone: 'America/Los_Angeles', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 750000 },
    { name: 'Denver', nameEn: 'Denver', nameZh: '丹佛', timezone: 'America/Denver', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 715000 },
    { name: 'Boston', nameEn: 'Boston', nameZh: '波士顿', timezone: 'America/New_York', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 685000 },
    { name: 'El Paso', nameEn: 'El Paso', nameZh: '埃尔帕索', timezone: 'America/Denver', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 680000 },
    { name: 'Nashville', nameEn: 'Nashville', nameZh: '纳什维尔', timezone: 'America/Chicago', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 670000 },
    { name: 'Detroit', nameEn: 'Detroit', nameZh: '底特律', timezone: 'America/Detroit', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 670000 },
    { name: 'Portland', nameEn: 'Portland', nameZh: '波特兰', timezone: 'America/Los_Angeles', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 650000 },
    { name: 'Las Vegas', nameEn: 'Las Vegas', nameZh: '拉斯维加斯', timezone: 'America/Los_Angeles', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 645000 },
    { name: 'Memphis', nameEn: 'Memphis', nameZh: '孟菲斯', timezone: 'America/Chicago', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 650000 },
    { name: 'Louisville', nameEn: 'Louisville', nameZh: '路易维尔', timezone: 'America/New_York', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 620000 },
    { name: 'Baltimore', nameEn: 'Baltimore', nameZh: '巴尔的摩', timezone: 'America/New_York', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 600000 },
    { name: 'Milwaukee', nameEn: 'Milwaukee', nameZh: '密尔沃基', timezone: 'America/Chicago', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 590000 },
    { name: 'Albuquerque', nameEn: 'Albuquerque', nameZh: '阿尔伯克基', timezone: 'America/Denver', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 560000 },
    { name: 'Honolulu', nameEn: 'Honolulu', nameZh: '檀香山', timezone: 'Pacific/Honolulu', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 350000 },
    { name: 'Anchorage', nameEn: 'Anchorage', nameZh: '安克雷奇', timezone: 'America/Anchorage', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 290000 },
    { name: 'Miami', nameEn: 'Miami', nameZh: '迈阿密', timezone: 'America/New_York', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 470000 },
    { name: 'Atlanta', nameEn: 'Atlanta', nameZh: '亚特兰大', timezone: 'America/New_York', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 500000 },
    { name: 'Minneapolis', nameEn: 'Minneapolis', nameZh: '明尼阿波利斯', timezone: 'America/Chicago', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 430000 },
    { name: 'Kansas City', nameEn: 'Kansas City', nameZh: '堪萨斯城', timezone: 'America/Chicago', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 510000 },
    { name: 'New Orleans', nameEn: 'New Orleans', nameZh: '新奥尔良', timezone: 'America/Chicago', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 390000 },
    { name: 'Cleveland', nameEn: 'Cleveland', nameZh: '克利夫兰', timezone: 'America/New_York', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 380000 },
    { name: 'Tampa', nameEn: 'Tampa', nameZh: '坦帕', timezone: 'America/New_York', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 400000 },
    { name: 'Raleigh', nameEn: 'Raleigh', nameZh: '罗利', timezone: 'America/New_York', country: 'United States', countryCode: 'US', flag: '🇺🇸', population: 470000 }
  ],

  JP: [
    { name: '東京', nameEn: 'Tokyo', nameZh: '东京', timezone: 'Asia/Tokyo', country: 'Japan', countryCode: 'JP', flag: '🇯🇵', population: 13960000 },
    { name: '横浜', nameEn: 'Yokohama', nameZh: '横滨', timezone: 'Asia/Tokyo', country: 'Japan', countryCode: 'JP', flag: '🇯🇵', population: 3750000 },
    { name: '大阪', nameEn: 'Osaka', nameZh: '大阪', timezone: 'Asia/Tokyo', country: 'Japan', countryCode: 'JP', flag: '🇯🇵', population: 2690000 },
    { name: '名古屋', nameEn: 'Nagoya', nameZh: '名古屋', timezone: 'Asia/Tokyo', country: 'Japan', countryCode: 'JP', flag: '🇯🇵', population: 2330000 },
    { name: '札幌', nameEn: 'Sapporo', nameZh: '札幌', timezone: 'Asia/Tokyo', country: 'Japan', countryCode: 'JP', flag: '🇯🇵', population: 1970000 },
    { name: '福岡', nameEn: 'Fukuoka', nameZh: '福冈', timezone: 'Asia/Tokyo', country: 'Japan', countryCode: 'JP', flag: '🇯🇵', population: 1610000 },
    { name: '神戸', nameEn: 'Kobe', nameZh: '神户', timezone: 'Asia/Tokyo', country: 'Japan', countryCode: 'JP', flag: '🇯🇵', population: 1540000 },
    { name: '川崎', nameEn: 'Kawasaki', nameZh: '川崎', timezone: 'Asia/Tokyo', country: 'Japan', countryCode: 'JP', flag: '🇯🇵', population: 1540000 },
    { name: '京都', nameEn: 'Kyoto', nameZh: '京都', timezone: 'Asia/Tokyo', country: 'Japan', countryCode: 'JP', flag: '🇯🇵', population: 1460000 },
    { name: 'さいたま', nameEn: 'Saitama', nameZh: '埼玉', timezone: 'Asia/Tokyo', country: 'Japan', countryCode: 'JP', flag: '🇯🇵', population: 1320000 },
    { name: '広島', nameEn: 'Hiroshima', nameZh: '广岛', timezone: 'Asia/Tokyo', country: 'Japan', countryCode: 'JP', flag: '🇯🇵', population: 1200000 },
    { name: '仙台', nameEn: 'Sendai', nameZh: '仙台', timezone: 'Asia/Tokyo', country: 'Japan', countryCode: 'JP', flag: '🇯🇵', population: 1090000 },
    { name: '北九州', nameEn: 'Kitakyushu', nameZh: '北九州', timezone: 'Asia/Tokyo', country: 'Japan', countryCode: 'JP', flag: '🇯🇵', population: 940000 },
    { name: '千葉', nameEn: 'Chiba', nameZh: '千叶', timezone: 'Asia/Tokyo', country: 'Japan', countryCode: 'JP', flag: '🇯🇵', population: 980000 },
    { name: '世田谷', nameEn: 'Setagaya', nameZh: '世田谷', timezone: 'Asia/Tokyo', country: 'Japan', countryCode: 'JP', flag: '🇯🇵', population: 920000 },
    { name: '堺', nameEn: 'Sakai', nameZh: '堺', timezone: 'Asia/Tokyo', country: 'Japan', countryCode: 'JP', flag: '🇯🇵', population: 830000 },
    { name: '新潟', nameEn: 'Niigata', nameZh: '新潟', timezone: 'Asia/Tokyo', country: 'Japan', countryCode: 'JP', flag: '🇯🇵', population: 800000 },
    { name: '浜松', nameEn: 'Hamamatsu', nameZh: '滨松', timezone: 'Asia/Tokyo', country: 'Japan', countryCode: 'JP', flag: '🇯🇵', population: 790000 },
    { name: '熊本', nameEn: 'Kumamoto', nameZh: '熊本', timezone: 'Asia/Tokyo', country: 'Japan', countryCode: 'JP', flag: '🇯🇵', population: 740000 },
    { name: '相模原', nameEn: 'Sagamihara', nameZh: '相模原', timezone: 'Asia/Tokyo', country: 'Japan', countryCode: 'JP', flag: '🇯🇵', population: 720000 },
    { name: '岡山', nameEn: 'Okayama', nameZh: '冈山', timezone: 'Asia/Tokyo', country: 'Japan', countryCode: 'JP', flag: '🇯🇵', population: 720000 },
    { name: '静岡', nameEn: 'Shizuoka', nameZh: '静冈', timezone: 'Asia/Tokyo', country: 'Japan', countryCode: 'JP', flag: '🇯🇵', population: 700000 },
    { name: '鹿児島', nameEn: 'Kagoshima', nameZh: '鹿儿岛', timezone: 'Asia/Tokyo', country: 'Japan', countryCode: 'JP', flag: '🇯🇵', population: 600000 },
    { name: '金沢', nameEn: 'Kanazawa', nameZh: '金泽', timezone: 'Asia/Tokyo', country: 'Japan', countryCode: 'JP', flag: '🇯🇵', population: 470000 },
    { name: '長崎', nameEn: 'Nagasaki', nameZh: '长崎', timezone: 'Asia/Tokyo', country: 'Japan', countryCode: 'JP', flag: '🇯🇵', population: 420000 },
    { name: '宇都宮', nameEn: 'Utsunomiya', nameZh: '宇都宫', timezone: 'Asia/Tokyo', country: 'Japan', countryCode: 'JP', flag: '🇯🇵', population: 520000 },
    { name: '松山', nameEn: 'Matsuyama', nameZh: '松山', timezone: 'Asia/Tokyo', country: 'Japan', countryCode: 'JP', flag: '🇯🇵', population: 510000 },
    { name: '大分', nameEn: 'Oita', nameZh: '大分', timezone: 'Asia/Tokyo', country: 'Japan', countryCode: 'JP', flag: '🇯🇵', population: 480000 },
    { name: '奈良', nameEn: 'Nara', nameZh: '奈良', timezone: 'Asia/Tokyo', country: 'Japan', countryCode: 'JP', flag: '🇯🇵', population: 360000 },
    { name: '長野', nameEn: 'Nagano', nameZh: '长野', timezone: 'Asia/Tokyo', country: 'Japan', countryCode: 'JP', flag: '🇯🇵', population: 380000 }
  ],

  GB: [
    { name: 'London', nameEn: 'London', nameZh: '伦敦', timezone: 'Europe/London', country: 'United Kingdom', countryCode: 'GB', flag: '🇬🇧', population: 9540000 },
    { name: 'Birmingham', nameEn: 'Birmingham', nameZh: '伯明翰', timezone: 'Europe/London', country: 'United Kingdom', countryCode: 'GB', flag: '🇬🇧', population: 2610000 },
    { name: 'Manchester', nameEn: 'Manchester', nameZh: '曼彻斯特', timezone: 'Europe/London', country: 'United Kingdom', countryCode: 'GB', flag: '🇬🇧', population: 2730000 },
    { name: 'Leeds', nameEn: 'Leeds', nameZh: '利兹', timezone: 'Europe/London', country: 'United Kingdom', countryCode: 'GB', flag: '🇬🇧', population: 1890000 },
    { name: 'Glasgow', nameEn: 'Glasgow', nameZh: '格拉斯哥', timezone: 'Europe/London', country: 'United Kingdom', countryCode: 'GB', flag: '🇬🇧', population: 1680000 },
    { name: 'Liverpool', nameEn: 'Liverpool', nameZh: '利物浦', timezone: 'Europe/London', country: 'United Kingdom', countryCode: 'GB', flag: '🇬🇧', population: 1420000 },
    { name: 'Sheffield', nameEn: 'Sheffield', nameZh: '谢菲尔德', timezone: 'Europe/London', country: 'United Kingdom', countryCode: 'GB', flag: '🇬🇧', population: 1260000 },
    { name: 'Edinburgh', nameEn: 'Edinburgh', nameZh: '爱丁堡', timezone: 'Europe/London', country: 'United Kingdom', countryCode: 'GB', flag: '🇬🇧', population: 1340000 },
    { name: 'Bristol', nameEn: 'Bristol', nameZh: '布里斯托', timezone: 'Europe/London', country: 'United Kingdom', countryCode: 'GB', flag: '🇬🇧', population: 1000000 },
    { name: 'Leicester', nameEn: 'Leicester', nameZh: '莱斯特', timezone: 'Europe/London', country: 'United Kingdom', countryCode: 'GB', flag: '🇬🇧', population: 470000 },
    { name: 'Coventry', nameEn: 'Coventry', nameZh: '考文垂', timezone: 'Europe/London', country: 'United Kingdom', countryCode: 'GB', flag: '🇬🇧', population: 370000 },
    { name: 'Nottingham', nameEn: 'Nottingham', nameZh: '诺丁汉', timezone: 'Europe/London', country: 'United Kingdom', countryCode: 'GB', flag: '🇬🇧', population: 730000 },
    { name: 'Newcastle', nameEn: 'Newcastle', nameZh: '纽卡斯尔', timezone: 'Europe/London', country: 'United Kingdom', countryCode: 'GB', flag: '🇬🇧', population: 1650000 },
    { name: 'Belfast', nameEn: 'Belfast', nameZh: '贝尔法斯特', timezone: 'Europe/London', country: 'United Kingdom', countryCode: 'GB', flag: '🇬🇧', population: 635000 },
    { name: 'Cardiff', nameEn: 'Cardiff', nameZh: '卡迪夫', timezone: 'Europe/London', country: 'United Kingdom', countryCode: 'GB', flag: '🇬🇧', population: 1180000 },
    { name: 'Bradford', nameEn: 'Bradford', nameZh: '布拉德福德', timezone: 'Europe/London', country: 'United Kingdom', countryCode: 'GB', flag: '🇬🇧', population: 540000 },
    { name: 'Hull', nameEn: 'Hull', nameZh: '赫尔', timezone: 'Europe/London', country: 'United Kingdom', countryCode: 'GB', flag: '🇬🇧', population: 580000 },
    { name: 'Stoke-on-Trent', nameEn: 'Stoke-on-Trent', nameZh: '特伦特河畔斯托克', timezone: 'Europe/London', country: 'United Kingdom', countryCode: 'GB', flag: '🇬🇧', population: 270000 },
    { name: 'Wolverhampton', nameEn: 'Wolverhampton', nameZh: '伍尔弗汉普顿', timezone: 'Europe/London', country: 'United Kingdom', countryCode: 'GB', flag: '🇬🇧', population: 270000 },
    { name: 'Plymouth', nameEn: 'Plymouth', nameZh: '普利茅斯', timezone: 'Europe/London', country: 'United Kingdom', countryCode: 'GB', flag: '🇬🇧', population: 270000 },
    { name: 'Southampton', nameEn: 'Southampton', nameZh: '南安普顿', timezone: 'Europe/London', country: 'United Kingdom', countryCode: 'GB', flag: '🇬🇧', population: 270000 },
    { name: 'Reading', nameEn: 'Reading', nameZh: '雷丁', timezone: 'Europe/London', country: 'United Kingdom', countryCode: 'GB', flag: '🇬🇧', population: 340000 },
    { name: 'Derby', nameEn: 'Derby', nameZh: '德比', timezone: 'Europe/London', country: 'United Kingdom', countryCode: 'GB', flag: '🇬🇧', population: 260000 },
    { name: 'Portsmouth', nameEn: 'Portsmouth', nameZh: '朴茨茅斯', timezone: 'Europe/London', country: 'United Kingdom', countryCode: 'GB', flag: '🇬🇧', population: 240000 },
    { name: 'York', nameEn: 'York', nameZh: '约克', timezone: 'Europe/London', country: 'United Kingdom', countryCode: 'GB', flag: '🇬🇧', population: 210000 },
    { name: 'Preston', nameEn: 'Preston', nameZh: '普雷斯顿', timezone: 'Europe/London', country: 'United Kingdom', countryCode: 'GB', flag: '🇬🇧', population: 180000 },
    { name: 'Swansea', nameEn: 'Swansea', nameZh: '斯旺西', timezone: 'Europe/London', country: 'United Kingdom', countryCode: 'GB', flag: '🇬🇧', population: 250000 },
    { name: 'Sunderland', nameEn: 'Sunderland', nameZh: '桑德兰', timezone: 'Europe/London', country: 'United Kingdom', countryCode: 'GB', flag: '🇬🇧', population: 280000 },
    { name: 'Oxford', nameEn: 'Oxford', nameZh: '牛津', timezone: 'Europe/London', country: 'United Kingdom', countryCode: 'GB', flag: '🇬🇧', population: 160000 },
    { name: 'Cambridge', nameEn: 'Cambridge', nameZh: '剑桥', timezone: 'Europe/London', country: 'United Kingdom', countryCode: 'GB', flag: '🇬🇧', population: 140000 }
  ],

  FR: [
    { name: 'Paris', nameEn: 'Paris', nameZh: '巴黎', timezone: 'Europe/Paris', country: 'France', countryCode: 'FR', flag: '🇫🇷', population: 11020000 },
    { name: 'Marseille', nameEn: 'Marseille', nameZh: '马赛', timezone: 'Europe/Paris', country: 'France', countryCode: 'FR', flag: '🇫🇷', population: 1760000 },
    { name: 'Lyon', nameEn: 'Lyon', nameZh: '里昂', timezone: 'Europe/Paris', country: 'France', countryCode: 'FR', flag: '🇫🇷', population: 2280000 },
    { name: 'Toulouse', nameEn: 'Toulouse', nameZh: '图卢兹', timezone: 'Europe/Paris', country: 'France', countryCode: 'FR', flag: '🇫🇷', population: 1360000 },
    { name: 'Nice', nameEn: 'Nice', nameZh: '尼斯', timezone: 'Europe/Paris', country: 'France', countryCode: 'FR', flag: '🇫🇷', population: 1000000 },
    { name: 'Nantes', nameEn: 'Nantes', nameZh: '南特', timezone: 'Europe/Paris', country: 'France', countryCode: 'FR', flag: '🇫🇷', population: 970000 },
    { name: 'Montpellier', nameEn: 'Montpellier', nameZh: '蒙彼利埃', timezone: 'Europe/Paris', country: 'France', countryCode: 'FR', flag: '🇫🇷', population: 610000 },
    { name: 'Strasbourg', nameEn: 'Strasbourg', nameZh: '斯特拉斯堡', timezone: 'Europe/Paris', country: 'France', countryCode: 'FR', flag: '🇫🇷', population: 790000 },
    { name: 'Bordeaux', nameEn: 'Bordeaux', nameZh: '波尔多', timezone: 'Europe/Paris', country: 'France', countryCode: 'FR', flag: '🇫🇷', population: 1280000 },
    { name: 'Lille', nameEn: 'Lille', nameZh: '里尔', timezone: 'Europe/Paris', country: 'France', countryCode: 'FR', flag: '🇫🇷', population: 1510000 },
    { name: 'Rennes', nameEn: 'Rennes', nameZh: '雷恩', timezone: 'Europe/Paris', country: 'France', countryCode: 'FR', flag: '🇫🇷', population: 740000 },
    { name: 'Reims', nameEn: 'Reims', nameZh: '兰斯', timezone: 'Europe/Paris', country: 'France', countryCode: 'FR', flag: '🇫🇷', population: 320000 },
    { name: 'Saint-Étienne', nameEn: 'Saint-Étienne', nameZh: '圣埃蒂安', timezone: 'Europe/Paris', country: 'France', countryCode: 'FR', flag: '🇫🇷', population: 510000 },
    { name: 'Toulon', nameEn: 'Toulon', nameZh: '土伦', timezone: 'Europe/Paris', country: 'France', countryCode: 'FR', flag: '🇫🇷', population: 580000 },
    { name: 'Le Havre', nameEn: 'Le Havre', nameZh: '勒阿弗尔', timezone: 'Europe/Paris', country: 'France', countryCode: 'FR', flag: '🇫🇷', population: 240000 },
    { name: 'Grenoble', nameEn: 'Grenoble', nameZh: '格勒诺布尔', timezone: 'Europe/Paris', country: 'France', countryCode: 'FR', flag: '🇫🇷', population: 690000 },
    { name: 'Dijon', nameEn: 'Dijon', nameZh: '第戎', timezone: 'Europe/Paris', country: 'France', countryCode: 'FR', flag: '🇫🇷', population: 390000 },
    { name: 'Angers', nameEn: 'Angers', nameZh: '昂热', timezone: 'Europe/Paris', country: 'France', countryCode: 'FR', flag: '🇫🇷', population: 410000 },
    { name: 'Nîmes', nameEn: 'Nîmes', nameZh: '尼姆', timezone: 'Europe/Paris', country: 'France', countryCode: 'FR', flag: '🇫🇷', population: 280000 },
    { name: 'Villeurbanne', nameEn: 'Villeurbanne', nameZh: '维勒班', timezone: 'Europe/Paris', country: 'France', countryCode: 'FR', flag: '🇫🇷', population: 150000 },
    { name: 'Clermont-Ferrand', nameEn: 'Clermont-Ferrand', nameZh: '克莱蒙费朗', timezone: 'Europe/Paris', country: 'France', countryCode: 'FR', flag: '🇫🇷', population: 470000 },
    { name: 'Aix-en-Provence', nameEn: 'Aix-en-Provence', nameZh: '艾克斯', timezone: 'Europe/Paris', country: 'France', countryCode: 'FR', flag: '🇫🇷', population: 150000 },
    { name: 'Brest', nameEn: 'Brest', nameZh: '布雷斯特', timezone: 'Europe/Paris', country: 'France', countryCode: 'FR', flag: '🇫🇷', population: 300000 },
    { name: 'Tours', nameEn: 'Tours', nameZh: '图尔', timezone: 'Europe/Paris', country: 'France', countryCode: 'FR', flag: '🇫🇷', population: 500000 },
    { name: 'Amiens', nameEn: 'Amiens', nameZh: '亚眠', timezone: 'Europe/Paris', country: 'France', countryCode: 'FR', flag: '🇫🇷', population: 290000 },
    { name: 'Limoges', nameEn: 'Limoges', nameZh: '利摩日', timezone: 'Europe/Paris', country: 'France', countryCode: 'FR', flag: '🇫🇷', population: 280000 },
    { name: 'Perpignan', nameEn: 'Perpignan', nameZh: '佩皮尼昂', timezone: 'Europe/Paris', country: 'France', countryCode: 'FR', flag: '🇫🇷', population: 270000 },
    { name: 'Besançon', nameEn: 'Besançon', nameZh: '贝桑松', timezone: 'Europe/Paris', country: 'France', countryCode: 'FR', flag: '🇫🇷', population: 250000 },
    { name: 'Metz', nameEn: 'Metz', nameZh: '梅斯', timezone: 'Europe/Paris', country: 'France', countryCode: 'FR', flag: '🇫🇷', population: 380000 },
    { name: 'Orléans', nameEn: 'Orléans', nameZh: '奥尔良', timezone: 'Europe/Paris', country: 'France', countryCode: 'FR', flag: '🇫🇷', population: 440000 }
  ],

  DE: [
    { name: 'Berlin', nameEn: 'Berlin', nameZh: '柏林', timezone: 'Europe/Berlin', country: 'Germany', countryCode: 'DE', flag: '🇩🇪', population: 3670000 },
    { name: 'Hamburg', nameEn: 'Hamburg', nameZh: '汉堡', timezone: 'Europe/Berlin', country: 'Germany', countryCode: 'DE', flag: '🇩🇪', population: 1900000 },
    { name: 'Munich', nameEn: 'Munich', nameZh: '慕尼黑', timezone: 'Europe/Berlin', country: 'Germany', countryCode: 'DE', flag: '🇩🇪', population: 1480000 },
    { name: 'Cologne', nameEn: 'Cologne', nameZh: '科隆', timezone: 'Europe/Berlin', country: 'Germany', countryCode: 'DE', flag: '🇩🇪', population: 1090000 },
    { name: 'Frankfurt', nameEn: 'Frankfurt', nameZh: '法兰克福', timezone: 'Europe/Berlin', country: 'Germany', countryCode: 'DE', flag: '🇩🇪', population: 750000 },
    { name: 'Stuttgart', nameEn: 'Stuttgart', nameZh: '斯图加特', timezone: 'Europe/Berlin', country: 'Germany', countryCode: 'DE', flag: '🇩🇪', population: 630000 },
    { name: 'Düsseldorf', nameEn: 'Düsseldorf', nameZh: '杜塞尔多夫', timezone: 'Europe/Berlin', country: 'Germany', countryCode: 'DE', flag: '🇩🇪', population: 620000 },
    { name: 'Leipzig', nameEn: 'Leipzig', nameZh: '莱比锡', timezone: 'Europe/Berlin', country: 'Germany', countryCode: 'DE', flag: '🇩🇪', population: 600000 },
    { name: 'Dortmund', nameEn: 'Dortmund', nameZh: '多特蒙德', timezone: 'Europe/Berlin', country: 'Germany', countryCode: 'DE', flag: '🇩🇪', population: 590000 },
    { name: 'Essen', nameEn: 'Essen', nameZh: '埃森', timezone: 'Europe/Berlin', country: 'Germany', countryCode: 'DE', flag: '🇩🇪', population: 580000 },
    { name: 'Bremen', nameEn: 'Bremen', nameZh: '不来梅', timezone: 'Europe/Berlin', country: 'Germany', countryCode: 'DE', flag: '🇩🇪', population: 570000 },
    { name: 'Dresden', nameEn: 'Dresden', nameZh: '德累斯顿', timezone: 'Europe/Berlin', country: 'Germany', countryCode: 'DE', flag: '🇩🇪', population: 560000 },
    { name: 'Hanover', nameEn: 'Hanover', nameZh: '汉诺威', timezone: 'Europe/Berlin', country: 'Germany', countryCode: 'DE', flag: '🇩🇪', population: 540000 },
    { name: 'Nuremberg', nameEn: 'Nuremberg', nameZh: '纽伦堡', timezone: 'Europe/Berlin', country: 'Germany', countryCode: 'DE', flag: '🇩🇪', population: 520000 },
    { name: 'Duisburg', nameEn: 'Duisburg', nameZh: '杜伊斯堡', timezone: 'Europe/Berlin', country: 'Germany', countryCode: 'DE', flag: '🇩🇪', population: 500000 },
    { name: 'Bochum', nameEn: 'Bochum', nameZh: '波鸿', timezone: 'Europe/Berlin', country: 'Germany', countryCode: 'DE', flag: '🇩🇪', population: 360000 },
    { name: 'Wuppertal', nameEn: 'Wuppertal', nameZh: '伍珀塔尔', timezone: 'Europe/Berlin', country: 'Germany', countryCode: 'DE', flag: '🇩🇪', population: 350000 },
    { name: 'Bielefeld', nameEn: 'Bielefeld', nameZh: '比勒费尔德', timezone: 'Europe/Berlin', country: 'Germany', countryCode: 'DE', flag: '🇩🇪', population: 340000 },
    { name: 'Bonn', nameEn: 'Bonn', nameZh: '波恩', timezone: 'Europe/Berlin', country: 'Germany', countryCode: 'DE', flag: '🇩🇪', population: 330000 },
    { name: 'Münster', nameEn: 'Münster', nameZh: '明斯特', timezone: 'Europe/Berlin', country: 'Germany', countryCode: 'DE', flag: '🇩🇪', population: 320000 },
    { name: 'Karlsruhe', nameEn: 'Karlsruhe', nameZh: '卡尔斯鲁厄', timezone: 'Europe/Berlin', country: 'Germany', countryCode: 'DE', flag: '🇩🇪', population: 310000 },
    { name: 'Mannheim', nameEn: 'Mannheim', nameZh: '曼海姆', timezone: 'Europe/Berlin', country: 'Germany', countryCode: 'DE', flag: '🇩🇪', population: 310000 },
    { name: 'Augsburg', nameEn: 'Augsburg', nameZh: '奥格斯堡', timezone: 'Europe/Berlin', country: 'Germany', countryCode: 'DE', flag: '🇩🇪', population: 300000 },
    { name: 'Wiesbaden', nameEn: 'Wiesbaden', nameZh: '威斯巴登', timezone: 'Europe/Berlin', country: 'Germany', countryCode: 'DE', flag: '🇩🇪', population: 290000 },
    { name: 'Gelsenkirchen', nameEn: 'Gelsenkirchen', nameZh: '盖尔森基兴', timezone: 'Europe/Berlin', country: 'Germany', countryCode: 'DE', flag: '🇩🇪', population: 260000 },
    { name: 'Mönchengladbach', nameEn: 'Mönchengladbach', nameZh: '门兴格拉德巴赫', timezone: 'Europe/Berlin', country: 'Germany', countryCode: 'DE', flag: '🇩🇪', population: 260000 },
    { name: 'Braunschweig', nameEn: 'Braunschweig', nameZh: '不伦瑞克', timezone: 'Europe/Berlin', country: 'Germany', countryCode: 'DE', flag: '🇩🇪', population: 250000 },
    { name: 'Chemnitz', nameEn: 'Chemnitz', nameZh: '开姆尼茨', timezone: 'Europe/Berlin', country: 'Germany', countryCode: 'DE', flag: '🇩🇪', population: 240000 },
    { name: 'Kiel', nameEn: 'Kiel', nameZh: '基尔', timezone: 'Europe/Berlin', country: 'Germany', countryCode: 'DE', flag: '🇩🇪', population: 250000 },
    { name: 'Aachen', nameEn: 'Aachen', nameZh: '亚琛', timezone: 'Europe/Berlin', country: 'Germany', countryCode: 'DE', flag: '🇩🇪', population: 250000 }
  ],

  AU: [
    { name: 'Sydney', nameEn: 'Sydney', nameZh: '悉尼', timezone: 'Australia/Sydney', country: 'Australia', countryCode: 'AU', flag: '🇦🇺', population: 5310000 },
    { name: 'Melbourne', nameEn: 'Melbourne', nameZh: '墨尔本', timezone: 'Australia/Melbourne', country: 'Australia', countryCode: 'AU', flag: '🇦🇺', population: 5080000 },
    { name: 'Brisbane', nameEn: 'Brisbane', nameZh: '布里斯班', timezone: 'Australia/Brisbane', country: 'Australia', countryCode: 'AU', flag: '🇦🇺', population: 2560000 },
    { name: 'Perth', nameEn: 'Perth', nameZh: '珀斯', timezone: 'Australia/Perth', country: 'Australia', countryCode: 'AU', flag: '🇦🇺', population: 2130000 },
    { name: 'Adelaide', nameEn: 'Adelaide', nameZh: '阿德莱德', timezone: 'Australia/Adelaide', country: 'Australia', countryCode: 'AU', flag: '🇦🇺', population: 1380000 },
    { name: 'Gold Coast', nameEn: 'Gold Coast', nameZh: '黄金海岸', timezone: 'Australia/Brisbane', country: 'Australia', countryCode: 'AU', flag: '🇦🇺', population: 680000 },
    { name: 'Newcastle', nameEn: 'Newcastle', nameZh: '纽卡斯尔', timezone: 'Australia/Sydney', country: 'Australia', countryCode: 'AU', flag: '🇦🇺', population: 480000 },
    { name: 'Canberra', nameEn: 'Canberra', nameZh: '堪培拉', timezone: 'Australia/Sydney', country: 'Australia', countryCode: 'AU', flag: '🇦🇺', population: 460000 },
    { name: 'Central Coast', nameEn: 'Central Coast', nameZh: '中央海岸', timezone: 'Australia/Sydney', country: 'Australia', countryCode: 'AU', flag: '🇦🇺', population: 340000 },
    { name: 'Wollongong', nameEn: 'Wollongong', nameZh: '卧龙岗', timezone: 'Australia/Sydney', country: 'Australia', countryCode: 'AU', flag: '🇦🇺', population: 300000 },
    { name: 'Logan City', nameEn: 'Logan City', nameZh: '洛根市', timezone: 'Australia/Brisbane', country: 'Australia', countryCode: 'AU', flag: '🇦🇺', population: 330000 },
    { name: 'Geelong', nameEn: 'Geelong', nameZh: '吉朗', timezone: 'Australia/Melbourne', country: 'Australia', countryCode: 'AU', flag: '🇦🇺', population: 250000 },
    { name: 'Hobart', nameEn: 'Hobart', nameZh: '霍巴特', timezone: 'Australia/Hobart', country: 'Australia', countryCode: 'AU', flag: '🇦🇺', population: 240000 },
    { name: 'Townsville', nameEn: 'Townsville', nameZh: '汤斯维尔', timezone: 'Australia/Brisbane', country: 'Australia', countryCode: 'AU', flag: '🇦🇺', population: 180000 },
    { name: 'Cairns', nameEn: 'Cairns', nameZh: '凯恩斯', timezone: 'Australia/Brisbane', country: 'Australia', countryCode: 'AU', flag: '🇦🇺', population: 150000 },
    { name: 'Toowoomba', nameEn: 'Toowoomba', nameZh: '图文巴', timezone: 'Australia/Brisbane', country: 'Australia', countryCode: 'AU', flag: '🇦🇺', population: 140000 },
    { name: 'Darwin', nameEn: 'Darwin', nameZh: '达尔文', timezone: 'Australia/Darwin', country: 'Australia', countryCode: 'AU', flag: '🇦🇺', population: 150000 },
    { name: 'Launceston', nameEn: 'Launceston', nameZh: '朗塞斯顿', timezone: 'Australia/Hobart', country: 'Australia', countryCode: 'AU', flag: '🇦🇺', population: 110000 },
    { name: 'Bendigo', nameEn: 'Bendigo', nameZh: '本迪戈', timezone: 'Australia/Melbourne', country: 'Australia', countryCode: 'AU', flag: '🇦🇺', population: 100000 },
    { name: 'Ballarat', nameEn: 'Ballarat', nameZh: '巴拉瑞特', timezone: 'Australia/Melbourne', country: 'Australia', countryCode: 'AU', flag: '🇦🇺', population: 110000 },
    { name: 'Mackay', nameEn: 'Mackay', nameZh: '麦凯', timezone: 'Australia/Brisbane', country: 'Australia', countryCode: 'AU', flag: '🇦🇺', population: 80000 },
    { name: 'Rockhampton', nameEn: 'Rockhampton', nameZh: '罗克汉普顿', timezone: 'Australia/Brisbane', country: 'Australia', countryCode: 'AU', flag: '🇦🇺', population: 80000 },
    { name: 'Bunbury', nameEn: 'Bunbury', nameZh: '班伯里', timezone: 'Australia/Perth', country: 'Australia', countryCode: 'AU', flag: '🇦🇺', population: 75000 },
    { name: 'Bundaberg', nameEn: 'Bundaberg', nameZh: '班德堡', timezone: 'Australia/Brisbane', country: 'Australia', countryCode: 'AU', flag: '🇦🇺', population: 70000 },
    { name: 'Wagga Wagga', nameEn: 'Wagga Wagga', nameZh: '瓦加瓦加', timezone: 'Australia/Sydney', country: 'Australia', countryCode: 'AU', flag: '🇦🇺', population: 70000 },
    { name: 'Hervey Bay', nameEn: 'Hervey Bay', nameZh: '赫维湾', timezone: 'Australia/Brisbane', country: 'Australia', countryCode: 'AU', flag: '🇦🇺', population: 65000 },
    { name: 'Maitland', nameEn: 'Maitland', nameZh: '梅特兰', timezone: 'Australia/Sydney', country: 'Australia', countryCode: 'AU', flag: '🇦🇺', population: 85000 },
    { name: 'Albury', nameEn: 'Albury', nameZh: '奥尔伯里', timezone: 'Australia/Sydney', country: 'Australia', countryCode: 'AU', flag: '🇦🇺', population: 55000 },
    { name: 'Sunshine Coast', nameEn: 'Sunshine Coast', nameZh: '阳光海岸', timezone: 'Australia/Brisbane', country: 'Australia', countryCode: 'AU', flag: '🇦🇺', population: 330000 },
    { name: 'Mandurah', nameEn: 'Mandurah', nameZh: '曼杜拉', timezone: 'Australia/Perth', country: 'Australia', countryCode: 'AU', flag: '🇦🇺', population: 100000 }
  ],

  SG: [
    { name: 'Singapore', nameEn: 'Singapore', nameZh: '新加坡', timezone: 'Asia/Singapore', country: 'Singapore', countryCode: 'SG', flag: '🇸🇬', population: 5900000 }
  ],

  RU: [
    { name: 'Moscow', nameEn: 'Moscow', nameZh: '莫斯科', timezone: 'Europe/Moscow', country: 'Russia', countryCode: 'RU', flag: '🇷🇺', population: 12640000 },
    { name: 'Saint Petersburg', nameEn: 'Saint Petersburg', nameZh: '圣彼得堡', timezone: 'Europe/Moscow', country: 'Russia', countryCode: 'RU', flag: '🇷🇺', population: 5380000 },
    { name: 'Novosibirsk', nameEn: 'Novosibirsk', nameZh: '新西伯利亚', timezone: 'Asia/Novosibirsk', country: 'Russia', countryCode: 'RU', flag: '🇷🇺', population: 1620000 },
    { name: 'Yekaterinburg', nameEn: 'Yekaterinburg', nameZh: '叶卡捷琳堡', timezone: 'Asia/Yekaterinburg', country: 'Russia', countryCode: 'RU', flag: '🇷🇺', population: 1490000 },
    { name: 'Kazan', nameEn: 'Kazan', nameZh: '喀山', timezone: 'Europe/Moscow', country: 'Russia', countryCode: 'RU', flag: '🇷🇺', population: 1260000 },
    { name: 'Nizhny Novgorod', nameEn: 'Nizhny Novgorod', nameZh: '下诺夫哥罗德', timezone: 'Europe/Moscow', country: 'Russia', countryCode: 'RU', flag: '🇷🇺', population: 1250000 },
    { name: 'Chelyabinsk', nameEn: 'Chelyabinsk', nameZh: '车里雅宾斯克', timezone: 'Asia/Yekaterinburg', country: 'Russia', countryCode: 'RU', flag: '🇷🇺', population: 1200000 },
    { name: 'Samara', nameEn: 'Samara', nameZh: '萨马拉', timezone: 'Europe/Samara', country: 'Russia', countryCode: 'RU', flag: '🇷🇺', population: 1160000 },
    { name: 'Omsk', nameEn: 'Omsk', nameZh: '鄂木斯克', timezone: 'Asia/Omsk', country: 'Russia', countryCode: 'RU', flag: '🇷🇺', population: 1150000 },
    { name: 'Rostov-on-Don', nameEn: 'Rostov-on-Don', nameZh: '顿河畔罗斯托夫', timezone: 'Europe/Moscow', country: 'Russia', countryCode: 'RU', flag: '🇷🇺', population: 1140000 },
    { name: 'Ufa', nameEn: 'Ufa', nameZh: '乌法', timezone: 'Asia/Yekaterinburg', country: 'Russia', countryCode: 'RU', flag: '🇷🇺', population: 1130000 },
    { name: 'Krasnoyarsk', nameEn: 'Krasnoyarsk', nameZh: '克拉斯诺亚尔斯克', timezone: 'Asia/Krasnoyarsk', country: 'Russia', countryCode: 'RU', flag: '🇷🇺', population: 1090000 },
    { name: 'Perm', nameEn: 'Perm', nameZh: '彼尔姆', timezone: 'Asia/Yekaterinburg', country: 'Russia', countryCode: 'RU', flag: '🇷🇺', population: 1050000 },
    { name: 'Voronezh', nameEn: 'Voronezh', nameZh: '沃罗涅日', timezone: 'Europe/Moscow', country: 'Russia', countryCode: 'RU', flag: '🇷🇺', population: 1050000 },
    { name: 'Volgograd', nameEn: 'Volgograd', nameZh: '伏尔加格勒', timezone: 'Europe/Volgograd', country: 'Russia', countryCode: 'RU', flag: '🇷🇺', population: 1000000 },
    { name: 'Krasnodar', nameEn: 'Krasnodar', nameZh: '克拉斯诺达尔', timezone: 'Europe/Moscow', country: 'Russia', countryCode: 'RU', flag: '🇷🇺', population: 950000 },
    { name: 'Saratov', nameEn: 'Saratov', nameZh: '萨拉托夫', timezone: 'Europe/Saratov', country: 'Russia', countryCode: 'RU', flag: '🇷🇺', population: 840000 },
    { name: 'Tyumen', nameEn: 'Tyumen', nameZh: '秋明', timezone: 'Asia/Yekaterinburg', country: 'Russia', countryCode: 'RU', flag: '🇷🇺', population: 810000 },
    { name: 'Tolyatti', nameEn: 'Tolyatti', nameZh: '陶里亚蒂', timezone: 'Europe/Samara', country: 'Russia', countryCode: 'RU', flag: '🇷🇺', population: 700000 },
    { name: 'Izhevsk', nameEn: 'Izhevsk', nameZh: '伊热夫斯克', timezone: 'Europe/Samara', country: 'Russia', countryCode: 'RU', flag: '🇷🇺', population: 650000 }
  ],

  // 加拿大
  CA: [
    { name: 'Toronto', nameEn: 'Toronto', nameZh: '多伦多', timezone: 'America/Toronto', country: 'Canada', countryCode: 'CA', flag: '🇨🇦', population: 2930000 },
    { name: 'Montreal', nameEn: 'Montreal', nameZh: '蒙特利尔', timezone: 'America/Toronto', country: 'Canada', countryCode: 'CA', flag: '🇨🇦', population: 1780000 },
    { name: 'Vancouver', nameEn: 'Vancouver', nameZh: '温哥华', timezone: 'America/Vancouver', country: 'Canada', countryCode: 'CA', flag: '🇨🇦', population: 675000 },
    { name: 'Calgary', nameEn: 'Calgary', nameZh: '卡尔加里', timezone: 'America/Edmonton', country: 'Canada', countryCode: 'CA', flag: '🇨🇦', population: 1340000 },
    { name: 'Edmonton', nameEn: 'Edmonton', nameZh: '埃德蒙顿', timezone: 'America/Edmonton', country: 'Canada', countryCode: 'CA', flag: '🇨🇦', population: 1010000 },
    { name: 'Ottawa', nameEn: 'Ottawa', nameZh: '渥太华', timezone: 'America/Toronto', country: 'Canada', countryCode: 'CA', flag: '🇨🇦', population: 1020000 }
  ],

  // 印度
  IN: [
    { name: 'Mumbai', nameEn: 'Mumbai', nameZh: '孟买', timezone: 'Asia/Kolkata', country: 'India', countryCode: 'IN', flag: '🇮🇳', population: 20410000 },
    { name: 'Delhi', nameEn: 'Delhi', nameZh: '德里', timezone: 'Asia/Kolkata', country: 'India', countryCode: 'IN', flag: '🇮🇳', population: 16780000 },
    { name: 'Bangalore', nameEn: 'Bangalore', nameZh: '班加罗尔', timezone: 'Asia/Kolkata', country: 'India', countryCode: 'IN', flag: '🇮🇳', population: 12340000 },
    { name: 'Hyderabad', nameEn: 'Hyderabad', nameZh: '海得拉巴', timezone: 'Asia/Kolkata', country: 'India', countryCode: 'IN', flag: '🇮🇳', population: 10010000 },
    { name: 'Chennai', nameEn: 'Chennai', nameZh: '金奈', timezone: 'Asia/Kolkata', country: 'India', countryCode: 'IN', flag: '🇮🇳', population: 10560000 },
    { name: 'Kolkata', nameEn: 'Kolkata', nameZh: '加尔各答', timezone: 'Asia/Kolkata', country: 'India', countryCode: 'IN', flag: '🇮🇳', population: 14850000 }
  ],

  // 韩国
  KR: [
    { name: 'Seoul', nameEn: 'Seoul', nameZh: '首尔', timezone: 'Asia/Seoul', country: 'South Korea', countryCode: 'KR', flag: '🇰🇷', population: 9770000 },
    { name: 'Busan', nameEn: 'Busan', nameZh: '釜山', timezone: 'Asia/Seoul', country: 'South Korea', countryCode: 'KR', flag: '🇰🇷', population: 3450000 },
    { name: 'Incheon', nameEn: 'Incheon', nameZh: '仁川', timezone: 'Asia/Seoul', country: 'South Korea', countryCode: 'KR', flag: '🇰🇷', population: 2950000 },
    { name: 'Daegu', nameEn: 'Daegu', nameZh: '大邱', timezone: 'Asia/Seoul', country: 'South Korea', countryCode: 'KR', flag: '🇰🇷', population: 2440000 }
  ],

  // 意大利
  IT: [
    { name: 'Rome', nameEn: 'Rome', nameZh: '罗马', timezone: 'Europe/Rome', country: 'Italy', countryCode: 'IT', flag: '🇮🇹', population: 2870000 },
    { name: 'Milan', nameEn: 'Milan', nameZh: '米兰', timezone: 'Europe/Rome', country: 'Italy', countryCode: 'IT', flag: '🇮🇹', population: 1400000 },
    { name: 'Naples', nameEn: 'Naples', nameZh: '那不勒斯', timezone: 'Europe/Rome', country: 'Italy', countryCode: 'IT', flag: '🇮🇹', population: 960000 },
    { name: 'Turin', nameEn: 'Turin', nameZh: '都灵', timezone: 'Europe/Rome', country: 'Italy', countryCode: 'IT', flag: '🇮🇹', population: 870000 }
  ],

  // 西班牙
  ES: [
    { name: 'Madrid', nameEn: 'Madrid', nameZh: '马德里', timezone: 'Europe/Madrid', country: 'Spain', countryCode: 'ES', flag: '🇪🇸', population: 3220000 },
    { name: 'Barcelona', nameEn: 'Barcelona', nameZh: '巴塞罗那', timezone: 'Europe/Madrid', country: 'Spain', countryCode: 'ES', flag: '🇪🇸', population: 1620000 },
    { name: 'Valencia', nameEn: 'Valencia', nameZh: '瓦伦西亚', timezone: 'Europe/Madrid', country: 'Spain', countryCode: 'ES', flag: '🇪🇸', population: 800000 },
    { name: 'Seville', nameEn: 'Seville', nameZh: '塞维利亚', timezone: 'Europe/Madrid', country: 'Spain', countryCode: 'ES', flag: '🇪🇸', population: 690000 }
  ],

  // 巴西
  BR: [
    { name: 'São Paulo', nameEn: 'São Paulo', nameZh: '圣保罗', timezone: 'America/Sao_Paulo', country: 'Brazil', countryCode: 'BR', flag: '🇧🇷', population: 12330000 },
    { name: 'Rio de Janeiro', nameEn: 'Rio de Janeiro', nameZh: '里约热内卢', timezone: 'America/Sao_Paulo', country: 'Brazil', countryCode: 'BR', flag: '🇧🇷', population: 6750000 },
    { name: 'Brasília', nameEn: 'Brasília', nameZh: '巴西利亚', timezone: 'America/Sao_Paulo', country: 'Brazil', countryCode: 'BR', flag: '🇧🇷', population: 3050000 }
  ],

  // 墨西哥
  MX: [
    { name: 'Mexico City', nameEn: 'Mexico City', nameZh: '墨西哥城', timezone: 'America/Mexico_City', country: 'Mexico', countryCode: 'MX', flag: '🇲🇽', population: 9210000 },
    { name: 'Guadalajara', nameEn: 'Guadalajara', nameZh: '瓜达拉哈拉', timezone: 'America/Mexico_City', country: 'Mexico', countryCode: 'MX', flag: '🇲🇽', population: 1560000 },
    { name: 'Monterrey', nameEn: 'Monterrey', nameZh: '蒙特雷', timezone: 'America/Monterrey', country: 'Mexico', countryCode: 'MX', flag: '🇲🇽', population: 1140000 }
  ],

  // 阿根廷
  AR: [
    { name: 'Buenos Aires', nameEn: 'Buenos Aires', nameZh: '布宜诺斯艾利斯', timezone: 'America/Argentina/Buenos_Aires', country: 'Argentina', countryCode: 'AR', flag: '🇦🇷', population: 3080000 },
    { name: 'Córdoba', nameEn: 'Córdoba', nameZh: '科尔多瓦', timezone: 'America/Argentina/Cordoba', country: 'Argentina', countryCode: 'AR', flag: '🇦🇷', population: 1330000 }
  ],

  // 荷兰
  NL: [
    { name: 'Amsterdam', nameEn: 'Amsterdam', nameZh: '阿姆斯特丹', timezone: 'Europe/Amsterdam', country: 'Netherlands', countryCode: 'NL', flag: '🇳🇱', population: 870000 },
    { name: 'Rotterdam', nameEn: 'Rotterdam', nameZh: '鹿特丹', timezone: 'Europe/Amsterdam', country: 'Netherlands', countryCode: 'NL', flag: '🇳🇱', population: 650000 }
  ],

  // 瑞士
  CH: [
    { name: 'Zurich', nameEn: 'Zurich', nameZh: '苏黎世', timezone: 'Europe/Zurich', country: 'Switzerland', countryCode: 'CH', flag: '🇨🇭', population: 420000 },
    { name: 'Geneva', nameEn: 'Geneva', nameZh: '日内瓦', timezone: 'Europe/Zurich', country: 'Switzerland', countryCode: 'CH', flag: '🇨🇭', population: 200000 }
  ],

  // 瑞典
  SE: [
    { name: 'Stockholm', nameEn: 'Stockholm', nameZh: '斯德哥尔摩', timezone: 'Europe/Stockholm', country: 'Sweden', countryCode: 'SE', flag: '🇸🇪', population: 980000 },
    { name: 'Gothenburg', nameEn: 'Gothenburg', nameZh: '哥德堡', timezone: 'Europe/Stockholm', country: 'Sweden', countryCode: 'SE', flag: '🇸🇪', population: 580000 }
  ],

  // 挪威
  NO: [
    { name: 'Oslo', nameEn: 'Oslo', nameZh: '奥斯陆', timezone: 'Europe/Oslo', country: 'Norway', countryCode: 'NO', flag: '🇳🇴', population: 700000 },
    { name: 'Bergen', nameEn: 'Bergen', nameZh: '卑尔根', timezone: 'Europe/Oslo', country: 'Norway', countryCode: 'NO', flag: '🇳🇴', population: 280000 }
  ],

  // 丹麦
  DK: [
    { name: 'Copenhagen', nameEn: 'Copenhagen', nameZh: '哥本哈根', timezone: 'Europe/Copenhagen', country: 'Denmark', countryCode: 'DK', flag: '🇩🇰', population: 630000 }
  ],

  // 芬兰
  FI: [
    { name: 'Helsinki', nameEn: 'Helsinki', nameZh: '赫尔辛基', timezone: 'Europe/Helsinki', country: 'Finland', countryCode: 'FI', flag: '🇫🇮', population: 660000 }
  ],

  // 波兰
  PL: [
    { name: 'Warsaw', nameEn: 'Warsaw', nameZh: '华沙', timezone: 'Europe/Warsaw', country: 'Poland', countryCode: 'PL', flag: '🇵🇱', population: 1790000 },
    { name: 'Kraków', nameEn: 'Kraków', nameZh: '克拉科夫', timezone: 'Europe/Warsaw', country: 'Poland', countryCode: 'PL', flag: '🇵🇱', population: 780000 }
  ],

  // 奥地利
  AT: [
    { name: 'Vienna', nameEn: 'Vienna', nameZh: '维也纳', timezone: 'Europe/Vienna', country: 'Austria', countryCode: 'AT', flag: '🇦🇹', population: 1910000 }
  ],

  // 土耳其
  TR: [
    { name: 'Istanbul', nameEn: 'Istanbul', nameZh: '伊斯坦布尔', timezone: 'Europe/Istanbul', country: 'Turkey', countryCode: 'TR', flag: '🇹🇷', population: 15460000 },
    { name: 'Ankara', nameEn: 'Ankara', nameZh: '安卡拉', timezone: 'Europe/Istanbul', country: 'Turkey', countryCode: 'TR', flag: '🇹🇷', population: 5660000 }
  ],

  // 埃及
  EG: [
    { name: 'Cairo', nameEn: 'Cairo', nameZh: '开罗', timezone: 'Africa/Cairo', country: 'Egypt', countryCode: 'EG', flag: '🇪🇬', population: 20900000 },
    { name: 'Alexandria', nameEn: 'Alexandria', nameZh: '亚历山大', timezone: 'Africa/Cairo', country: 'Egypt', countryCode: 'EG', flag: '🇪🇬', population: 5200000 }
  ],

  // 南非
  ZA: [
    { name: 'Johannesburg', nameEn: 'Johannesburg', nameZh: '约翰内斯堡', timezone: 'Africa/Johannesburg', country: 'South Africa', countryCode: 'ZA', flag: '🇿🇦', population: 5780000 },
    { name: 'Cape Town', nameEn: 'Cape Town', nameZh: '开普敦', timezone: 'Africa/Johannesburg', country: 'South Africa', countryCode: 'ZA', flag: '🇿🇦', population: 4620000 }
  ],

  // 阿联酋
  AE: [
    { name: 'Dubai', nameEn: 'Dubai', nameZh: '迪拜', timezone: 'Asia/Dubai', country: 'United Arab Emirates', countryCode: 'AE', flag: '🇦🇪', population: 3330000 },
    { name: 'Abu Dhabi', nameEn: 'Abu Dhabi', nameZh: '阿布扎比', timezone: 'Asia/Dubai', country: 'United Arab Emirates', countryCode: 'AE', flag: '🇦🇪', population: 1480000 }
  ],

  // 泰国
  TH: [
    { name: 'Bangkok', nameEn: 'Bangkok', nameZh: '曼谷', timezone: 'Asia/Bangkok', country: 'Thailand', countryCode: 'TH', flag: '🇹🇭', population: 10540000 },
    { name: 'Chiang Mai', nameEn: 'Chiang Mai', nameZh: '清迈', timezone: 'Asia/Bangkok', country: 'Thailand', countryCode: 'TH', flag: '🇹🇭', population: 130000 }
  ],

  // 越南
  VN: [
    { name: 'Ho Chi Minh City', nameEn: 'Ho Chi Minh City', nameZh: '胡志明市', timezone: 'Asia/Ho_Chi_Minh', country: 'Vietnam', countryCode: 'VN', flag: '🇻🇳', population: 9000000 },
    { name: 'Hanoi', nameEn: 'Hanoi', nameZh: '河内', timezone: 'Asia/Ho_Chi_Minh', country: 'Vietnam', countryCode: 'VN', flag: '🇻🇳', population: 8250000 }
  ],

  // 马来西亚
  MY: [
    { name: 'Kuala Lumpur', nameEn: 'Kuala Lumpur', nameZh: '吉隆坡', timezone: 'Asia/Kuala_Lumpur', country: 'Malaysia', countryCode: 'MY', flag: '🇲🇾', population: 1800000 }
  ],

  // 印度尼西亚
  ID: [
    { name: 'Jakarta', nameEn: 'Jakarta', nameZh: '雅加达', timezone: 'Asia/Jakarta', country: 'Indonesia', countryCode: 'ID', flag: '🇮🇩', population: 10560000 },
    { name: 'Surabaya', nameEn: 'Surabaya', nameZh: '泗水', timezone: 'Asia/Jakarta', country: 'Indonesia', countryCode: 'ID', flag: '🇮🇩', population: 2870000 }
  ],

  // 菲律宾
  PH: [
    { name: 'Manila', nameEn: 'Manila', nameZh: '马尼拉', timezone: 'Asia/Manila', country: 'Philippines', countryCode: 'PH', flag: '🇵🇭', population: 1780000 }
  ],

  // 新西兰
  NZ: [
    { name: 'Auckland', nameEn: 'Auckland', nameZh: '奥克兰', timezone: 'Pacific/Auckland', country: 'New Zealand', countryCode: 'NZ', flag: '🇳🇿', population: 1660000 },
    { name: 'Wellington', nameEn: 'Wellington', nameZh: '惠灵顿', timezone: 'Pacific/Auckland', country: 'New Zealand', countryCode: 'NZ', flag: '🇳🇿', population: 210000 }
  ],

  // 智利
  CL: [
    { name: 'Santiago', nameEn: 'Santiago', nameZh: '圣地亚哥', timezone: 'America/Santiago', country: 'Chile', countryCode: 'CL', flag: '🇨🇱', population: 6680000 }
  ],

  // 葡萄牙
  PT: [
    { name: 'Lisbon', nameEn: 'Lisbon', nameZh: '里斯本', timezone: 'Europe/Lisbon', country: 'Portugal', countryCode: 'PT', flag: '🇵🇹', population: 550000 },
    { name: 'Porto', nameEn: 'Porto', nameZh: '波尔图', timezone: 'Europe/Lisbon', country: 'Portugal', countryCode: 'PT', flag: '🇵🇹', population: 230000 }
  ],

  // 希腊
  GR: [
    { name: 'Athens', nameEn: 'Athens', nameZh: '雅典', timezone: 'Europe/Athens', country: 'Greece', countryCode: 'GR', flag: '🇬🇷', population: 3150000 }
  ],

  // 比利时
  BE: [
    { name: 'Brussels', nameEn: 'Brussels', nameZh: '布鲁塞尔', timezone: 'Europe/Brussels', country: 'Belgium', countryCode: 'BE', flag: '🇧🇪', population: 1210000 }
  ],

  // 爱尔兰
  IE: [
    { name: 'Dublin', nameEn: 'Dublin', nameZh: '都柏林', timezone: 'Europe/Dublin', country: 'Ireland', countryCode: 'IE', flag: '🇮🇪', population: 1230000 }
  ],

  // 捷克
  CZ: [
    { name: 'Prague', nameEn: 'Prague', nameZh: '布拉格', timezone: 'Europe/Prague', country: 'Czech Republic', countryCode: 'CZ', flag: '🇨🇿', population: 1310000 }
  ],

  // 匈牙利
  HU: [
    { name: 'Budapest', nameEn: 'Budapest', nameZh: '布达佩斯', timezone: 'Europe/Budapest', country: 'Hungary', countryCode: 'HU', flag: '🇭🇺', population: 1750000 }
  ],

  // 罗马尼亚
  RO: [
    { name: 'Bucharest', nameEn: 'Bucharest', nameZh: '布加勒斯特', timezone: 'Europe/Bucharest', country: 'Romania', countryCode: 'RO', flag: '🇷🇴', population: 1830000 }
  ],

  // 乌克兰
  UA: [
    { name: 'Kyiv', nameEn: 'Kyiv', nameZh: '基辅', timezone: 'Europe/Kyiv', country: 'Ukraine', countryCode: 'UA', flag: '🇺🇦', population: 2960000 }
  ],

  // 以色列
  IL: [
    { name: 'Tel Aviv', nameEn: 'Tel Aviv', nameZh: '特拉维夫', timezone: 'Asia/Jerusalem', country: 'Israel', countryCode: 'IL', flag: '🇮🇱', population: 460000 },
    { name: 'Jerusalem', nameEn: 'Jerusalem', nameZh: '耶路撒冷', timezone: 'Asia/Jerusalem', country: 'Israel', countryCode: 'IL', flag: '🇮🇱', population: 930000 }
  ],

  // 沙特阿拉伯
  SA: [
    { name: 'Riyadh', nameEn: 'Riyadh', nameZh: '利雅得', timezone: 'Asia/Riyadh', country: 'Saudi Arabia', countryCode: 'SA', flag: '🇸🇦', population: 7680000 }
  ],

  // 巴基斯坦
  PK: [
    { name: 'Karachi', nameEn: 'Karachi', nameZh: '卡拉奇', timezone: 'Asia/Karachi', country: 'Pakistan', countryCode: 'PK', flag: '🇵🇰', population: 16050000 },
    { name: 'Lahore', nameEn: 'Lahore', nameZh: '拉合尔', timezone: 'Asia/Karachi', country: 'Pakistan', countryCode: 'PK', flag: '🇵🇰', population: 11130000 }
  ],

  // 孟加拉国
  BD: [
    { name: 'Dhaka', nameEn: 'Dhaka', nameZh: '达卡', timezone: 'Asia/Dhaka', country: 'Bangladesh', countryCode: 'BD', flag: '🇧🇩', population: 21000000 }
  ],

  // 伊朗
  IR: [
    { name: 'Tehran', nameEn: 'Tehran', nameZh: '德黑兰', timezone: 'Asia/Tehran', country: 'Iran', countryCode: 'IR', flag: '🇮🇷', population: 8900000 }
  ],

  // 伊拉克
  IQ: [
    { name: 'Baghdad', nameEn: 'Baghdad', nameZh: '巴格达', timezone: 'Asia/Baghdad', country: 'Iraq', countryCode: 'IQ', flag: '🇮🇶', population: 7220000 }
  ],

  // 尼日利亚
  NG: [
    { name: 'Lagos', nameEn: 'Lagos', nameZh: '拉各斯', timezone: 'Africa/Lagos', country: 'Nigeria', countryCode: 'NG', flag: '🇳🇬', population: 14370000 }
  ],

  // 肯尼亚
  KE: [
    { name: 'Nairobi', nameEn: 'Nairobi', nameZh: '内罗毕', timezone: 'Africa/Nairobi', country: 'Kenya', countryCode: 'KE', flag: '🇰🇪', population: 4400000 }
  ],

  // 阿尔及利亚
  DZ: [
    { name: 'Algiers', nameEn: 'Algiers', nameZh: '阿尔及尔', timezone: 'Africa/Algiers', country: 'Algeria', countryCode: 'DZ', flag: '🇩🇿', population: 2700000 }
  ],

  // 摩洛哥
  MA: [
    { name: 'Casablanca', nameEn: 'Casablanca', nameZh: '卡萨布兰卡', timezone: 'Africa/Casablanca', country: 'Morocco', countryCode: 'MA', flag: '🇲🇦', population: 3360000 }
  ],

  // 哥伦比亚
  CO: [
    { name: 'Bogotá', nameEn: 'Bogotá', nameZh: '波哥大', timezone: 'America/Bogota', country: 'Colombia', countryCode: 'CO', flag: '🇨🇴', population: 7410000 }
  ],

  // 秘鲁
  PE: [
    { name: 'Lima', nameEn: 'Lima', nameZh: '利马', timezone: 'America/Lima', country: 'Peru', countryCode: 'PE', flag: '🇵🇪', population: 9750000 }
  ],

  // 委内瑞拉
  VE: [
    { name: 'Caracas', nameEn: 'Caracas', nameZh: '加拉加斯', timezone: 'America/Caracas', country: 'Venezuela', countryCode: 'VE', flag: '🇻🇪', population: 2930000 }
  ],

  // 厄瓜多尔
  EC: [
    { name: 'Quito', nameEn: 'Quito', nameZh: '基多', timezone: 'America/Guayaquil', country: 'Ecuador', countryCode: 'EC', flag: '🇪🇨', population: 2010000 }
  ],

  // 古巴
  CU: [
    { name: 'Havana', nameEn: 'Havana', nameZh: '哈瓦那', timezone: 'America/Havana', country: 'Cuba', countryCode: 'CU', flag: '🇨🇺', population: 2130000 }
  ],

  // 多米尼加
  DO: [
    { name: 'Santo Domingo', nameEn: 'Santo Domingo', nameZh: '圣多明各', timezone: 'America/Santo_Domingo', country: 'Dominican Republic', countryCode: 'DO', flag: '🇩🇴', population: 3660000 }
  ],

  // 波多黎各
  PR: [
    { name: 'San Juan', nameEn: 'San Juan', nameZh: '圣胡安', timezone: 'America/Puerto_Rico', country: 'Puerto Rico', countryCode: 'PR', flag: '🇵🇷', population: 320000 }
  ],

  // 牙买加
  JM: [
    { name: 'Kingston', nameEn: 'Kingston', nameZh: '金斯顿', timezone: 'America/Jamaica', country: 'Jamaica', countryCode: 'JM', flag: '🇯🇲', population: 590000 }
  ],

  // 哥斯达黎加
  CR: [
    { name: 'San José', nameEn: 'San José', nameZh: '圣何塞', timezone: 'America/Costa_Rica', country: 'Costa Rica', countryCode: 'CR', flag: '🇨🇷', population: 340000 }
  ],

  // 巴拿马
  PA: [
    { name: 'Panama City', nameEn: 'Panama City', nameZh: '巴拿马城', timezone: 'America/Panama', country: 'Panama', countryCode: 'PA', flag: '🇵🇦', population: 880000 }
  ],

  // 危地马拉
  GT: [
    { name: 'Guatemala City', nameEn: 'Guatemala City', nameZh: '危地马拉城', timezone: 'America/Guatemala', country: 'Guatemala', countryCode: 'GT', flag: '🇬🇹', population: 2930000 }
  ],

  // 乌拉圭
  UY: [
    { name: 'Montevideo', nameEn: 'Montevideo', nameZh: '蒙得维的亚', timezone: 'America/Montevideo', country: 'Uruguay', countryCode: 'UY', flag: '🇺🇾', population: 1320000 }
  ],

  // 巴拉圭
  PY: [
    { name: 'Asunción', nameEn: 'Asunción', nameZh: '亚松森', timezone: 'America/Asuncion', country: 'Paraguay', countryCode: 'PY', flag: '🇵🇾', population: 520000 }
  ],

  // 玻利维亚
  BO: [
    { name: 'La Paz', nameEn: 'La Paz', nameZh: '拉巴斯', timezone: 'America/La_Paz', country: 'Bolivia', countryCode: 'BO', flag: '🇧🇴', population: 760000 }
  ],

  // 洪都拉斯
  HN: [
    { name: 'Tegucigalpa', nameEn: 'Tegucigalpa', nameZh: '特古西加尔巴', timezone: 'America/Tegucigalpa', country: 'Honduras', countryCode: 'HN', flag: '🇭🇳', population: 1400000 }
  ],

  // 萨尔瓦多
  SV: [
    { name: 'San Salvador', nameEn: 'San Salvador', nameZh: '圣萨尔瓦多', timezone: 'America/El_Salvador', country: 'El Salvador', countryCode: 'SV', flag: '🇸🇻', population: 570000 }
  ],

  // 尼加拉瓜
  NI: [
    { name: 'Managua', nameEn: 'Managua', nameZh: '马那瓜', timezone: 'America/Managua', country: 'Nicaragua', countryCode: 'NI', flag: '🇳🇮', population: 1050000 }
  ],

  // 冰岛
  IS: [
    { name: 'Reykjavik', nameEn: 'Reykjavik', nameZh: '雷克雅未克', timezone: 'Atlantic/Reykjavik', country: 'Iceland', countryCode: 'IS', flag: '🇮🇸', population: 130000 }
  ],

  // 卢森堡
  LU: [
    { name: 'Luxembourg', nameEn: 'Luxembourg', nameZh: '卢森堡', timezone: 'Europe/Luxembourg', country: 'Luxembourg', countryCode: 'LU', flag: '🇱🇺', population: 120000 }
  ],

  // 斯洛伐克
  SK: [
    { name: 'Bratislava', nameEn: 'Bratislava', nameZh: '布拉迪斯拉发', timezone: 'Europe/Bratislava', country: 'Slovakia', countryCode: 'SK', flag: '🇸🇰', population: 430000 }
  ],

  // 斯洛文尼亚
  SI: [
    { name: 'Ljubljana', nameEn: 'Ljubljana', nameZh: '卢布尔雅那', timezone: 'Europe/Ljubljana', country: 'Slovenia', countryCode: 'SI', flag: '🇸🇮', population: 280000 }
  ],

  // 克罗地亚
  HR: [
    { name: 'Zagreb', nameEn: 'Zagreb', nameZh: '萨格勒布', timezone: 'Europe/Zagreb', country: 'Croatia', countryCode: 'HR', flag: '🇭🇷', population: 790000 }
  ],

  // 塞尔维亚
  RS: [
    { name: 'Belgrade', nameEn: 'Belgrade', nameZh: '贝尔格莱德', timezone: 'Europe/Belgrade', country: 'Serbia', countryCode: 'RS', flag: '🇷🇸', population: 1380000 }
  ],

  // 保加利亚
  BG: [
    { name: 'Sofia', nameEn: 'Sofia', nameZh: '索非亚', timezone: 'Europe/Sofia', country: 'Bulgaria', countryCode: 'BG', flag: '🇧🇬', population: 1240000 }
  ],

  // 立陶宛
  LT: [
    { name: 'Vilnius', nameEn: 'Vilnius', nameZh: '维尔纽斯', timezone: 'Europe/Vilnius', country: 'Lithuania', countryCode: 'LT', flag: '🇱🇹', population: 580000 }
  ],

  // 拉脱维亚
  LV: [
    { name: 'Riga', nameEn: 'Riga', nameZh: '里加', timezone: 'Europe/Riga', country: 'Latvia', countryCode: 'LV', flag: '🇱🇻', population: 630000 }
  ],

  // 爱沙尼亚
  EE: [
    { name: 'Tallinn', nameEn: 'Tallinn', nameZh: '塔林', timezone: 'Europe/Tallinn', country: 'Estonia', countryCode: 'EE', flag: '🇪🇪', population: 440000 }
  ],

  // 白俄罗斯
  BY: [
    { name: 'Minsk', nameEn: 'Minsk', nameZh: '明斯克', timezone: 'Europe/Minsk', country: 'Belarus', countryCode: 'BY', flag: '🇧🇾', population: 2020000 }
  ],

  // 缅甸
  MM: [
    { name: 'Yangon', nameEn: 'Yangon', nameZh: '仰光', timezone: 'Asia/Yangon', country: 'Myanmar', countryCode: 'MM', flag: '🇲🇲', population: 5420000 }
  ],

  // 柬埔寨
  KH: [
    { name: 'Phnom Penh', nameEn: 'Phnom Penh', nameZh: '金边', timezone: 'Asia/Phnom_Penh', country: 'Cambodia', countryCode: 'KH', flag: '🇰🇭', population: 2280000 }
  ],

  // 老挝
  LA: [
    { name: 'Vientiane', nameEn: 'Vientiane', nameZh: '万象', timezone: 'Asia/Vientiane', country: 'Laos', countryCode: 'LA', flag: '🇱🇦', population: 820000 }
  ],

  // 蒙古
  MN: [
    { name: 'Ulaanbaatar', nameEn: 'Ulaanbaatar', nameZh: '乌兰巴托', timezone: 'Asia/Ulaanbaatar', country: 'Mongolia', countryCode: 'MN', flag: '🇲🇳', population: 1380000 }
  ],

  // 尼泊尔
  NP: [
    { name: 'Kathmandu', nameEn: 'Kathmandu', nameZh: '加德满都', timezone: 'Asia/Kathmandu', country: 'Nepal', countryCode: 'NP', flag: '🇳🇵', population: 1180000 }
  ],

  // 斯里兰卡
  LK: [
    { name: 'Colombo', nameEn: 'Colombo', nameZh: '科伦坡', timezone: 'Asia/Colombo', country: 'Sri Lanka', countryCode: 'LK', flag: '🇱🇰', population: 750000 }
  ],

  // 阿富汗
  AF: [
    { name: 'Kabul', nameEn: 'Kabul', nameZh: '喀布尔', timezone: 'Asia/Kabul', country: 'Afghanistan', countryCode: 'AF', flag: '🇦🇫', population: 4270000 }
  ],

  // 哈萨克斯坦
  KZ: [
    { name: 'Almaty', nameEn: 'Almaty', nameZh: '阿拉木图', timezone: 'Asia/Almaty', country: 'Kazakhstan', countryCode: 'KZ', flag: '🇰🇿', population: 1920000 }
  ],

  // 乌兹别克斯坦
  UZ: [
    { name: 'Tashkent', nameEn: 'Tashkent', nameZh: '塔什干', timezone: 'Asia/Tashkent', country: 'Uzbekistan', countryCode: 'UZ', flag: '🇺🇿', population: 2530000 }
  ],

  // 格鲁吉亚
  GE: [
    { name: 'Tbilisi', nameEn: 'Tbilisi', nameZh: '第比利斯', timezone: 'Asia/Tbilisi', country: 'Georgia', countryCode: 'GE', flag: '🇬🇪', population: 1120000 }
  ],

  // 亚美尼亚
  AM: [
    { name: 'Yerevan', nameEn: 'Yerevan', nameZh: '埃里温', timezone: 'Asia/Yerevan', country: 'Armenia', countryCode: 'AM', flag: '🇦🇲', population: 1080000 }
  ],

  // 阿塞拜疆
  AZ: [
    { name: 'Baku', nameEn: 'Baku', nameZh: '巴库', timezone: 'Asia/Baku', country: 'Azerbaijan', countryCode: 'AZ', flag: '🇦🇿', population: 2300000 }
  ],

  // 卡塔尔
  QA: [
    { name: 'Doha', nameEn: 'Doha', nameZh: '多哈', timezone: 'Asia/Qatar', country: 'Qatar', countryCode: 'QA', flag: '🇶🇦', population: 640000 }
  ],

  // 科威特
  KW: [
    { name: 'Kuwait City', nameEn: 'Kuwait City', nameZh: '科威特城', timezone: 'Asia/Kuwait', country: 'Kuwait', countryCode: 'KW', flag: '🇰🇼', population: 420000 }
  ],

  // 巴林
  BH: [
    { name: 'Manama', nameEn: 'Manama', nameZh: '麦纳麦', timezone: 'Asia/Bahrain', country: 'Bahrain', countryCode: 'BH', flag: '🇧🇭', population: 200000 }
  ],

  // 阿曼
  OM: [
    { name: 'Muscat', nameEn: 'Muscat', nameZh: '马斯喀特', timezone: 'Asia/Muscat', country: 'Oman', countryCode: 'OM', flag: '🇴🇲', population: 1420000 }
  ],

  // 约旦
  JO: [
    { name: 'Amman', nameEn: 'Amman', nameZh: '安曼', timezone: 'Asia/Amman', country: 'Jordan', countryCode: 'JO', flag: '🇯🇴', population: 2070000 }
  ],

  // 黎巴嫩
  LB: [
    { name: 'Beirut', nameEn: 'Beirut', nameZh: '贝鲁特', timezone: 'Asia/Beirut', country: 'Lebanon', countryCode: 'LB', flag: '🇱🇧', population: 2390000 }
  ],

  // 文莱
  BN: [
    { name: 'Bandar Seri Begawan', nameEn: 'Bandar Seri Begawan', nameZh: '斯里巴加湾市', timezone: 'Asia/Brunei', country: 'Brunei', countryCode: 'BN', flag: '🇧🇳', population: 100000 }
  ],

  // 东帝汶
  TL: [
    { name: 'Dili', nameEn: 'Dili', nameZh: '帝力', timezone: 'Asia/Dili', country: 'Timor-Leste', countryCode: 'TL', flag: '🇹🇱', population: 230000 }
  ],

  // 马尔代夫
  MV: [
    { name: 'Malé', nameEn: 'Malé', nameZh: '马累', timezone: 'Indian/Maldives', country: 'Maldives', countryCode: 'MV', flag: '🇲🇻', population: 130000 }
  ],

  // 不丹
  BT: [
    { name: 'Thimphu', nameEn: 'Thimphu', nameZh: '廷布', timezone: 'Asia/Thimphu', country: 'Bhutan', countryCode: 'BT', flag: '🇧🇹', population: 110000 }
  ],

  // 斐济
  FJ: [
    { name: 'Suva', nameEn: 'Suva', nameZh: '苏瓦', timezone: 'Pacific/Fiji', country: 'Fiji', countryCode: 'FJ', flag: '🇫🇯', population: 90000 }
  ],

  // 巴布亚新几内亚
  PG: [
    { name: 'Port Moresby', nameEn: 'Port Moresby', nameZh: '莫尔兹比港', timezone: 'Pacific/Port_Moresby', country: 'Papua New Guinea', countryCode: 'PG', flag: '🇵🇬', population: 380000 }
  ]
};

// 根据城市名获取国家代码
export const getCityCountryCode = (cityName: string): string | null => {
  for (const [countryCode, cities] of Object.entries(popularCitiesByCountry)) {
    const found = cities.find(city => 
      city.name === cityName || 
      city.nameEn === cityName || 
      city.nameZh === cityName
    );
    if (found) {
      return countryCode;
    }
  }
  return null;
};

// 根据城市名获取城市数据
export const getCityData = (cityName: string): CityData | null => {
  if (!cityName) return null;
  
  console.log('getCityData searching for:', cityName);
  
  for (const cities of Object.values(popularCitiesByCountry)) {
    const found = cities.find(city => {
      const matches = city.name === cityName || 
                     city.nameEn === cityName || 
                     city.nameZh === cityName ||
                     city.name.toLowerCase() === cityName.toLowerCase() ||
                     city.nameEn.toLowerCase() === cityName.toLowerCase() ||
                     city.nameZh.toLowerCase() === cityName.toLowerCase();
      
      if (matches) {
        console.log('Found match:', city);
      }
      return matches;
    });
    if (found) {
      return found;
    }
  }
  
  console.log('No city found for:', cityName);
  return null;
};

// 获取国家的所有城市
export const getCitiesByCountry = (countryCode: string): CityData[] => {
  return popularCitiesByCountry[countryCode] || [];
};

// URL友好的城市名称转换
export const cityNameToUrlSlug = (cityName: string): string => {
  return cityName
    .toLowerCase()
    .replace(/[^a-z0-9\s-']/g, '') // 保留英文字母、数字、空格、连字符和撇号
    .replace(/'/g, '') // 移除撇号 (如 Xi'an -> xian)
    .replace(/\s+/g, '-') // 空格转连字符
    .replace(/-+/g, '-') // 多个连字符合并为一个
    .replace(/^-+|-+$/g, '') // 移除开头和结尾的连字符
    .trim();
};

// URL slug转回城市名称
export const urlSlugToCityName = (slug: string): string => {
  return slug
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

// 国家信息接口
export interface CountryInfo {
  countryCode: string;
  countryName: string;
  countryNameZh: string;
  flag: string;
  citiesCount: number;
}

// 获取所有国家列表
export const getAllCountries = (): CountryInfo[] => {
  const countryMap: Record<string, CountryInfo> = {};

  Object.entries(popularCitiesByCountry).forEach(([countryCode, cities]) => {
    if (cities.length > 0) {
      const firstCity = cities[0];
      countryMap[countryCode] = {
        countryCode,
        countryName: firstCity.country,
        countryNameZh: getCountryNameZh(firstCity.country),
        flag: firstCity.flag,
        citiesCount: cities.length
      };
    }
  });

  return Object.values(countryMap);
};

// 国家中文名映射
const getCountryNameZh = (countryNameEn: string): string => {
  const countryNameMap: Record<string, string> = {
    'China': '中国',
    'United States': '美国',
    'Japan': '日本',
    'United Kingdom': '英国',
    'France': '法国',
    'Germany': '德国',
    'Australia': '澳大利亚',
    'Singapore': '新加坡',
    'Russia': '俄罗斯',
    'Canada': '加拿大',
    'India': '印度',
    'South Korea': '韩国',
    'Italy': '意大利',
    'Spain': '西班牙',
    'Brazil': '巴西',
    'Mexico': '墨西哥',
    'Argentina': '阿根廷',
    'Netherlands': '荷兰',
    'Switzerland': '瑞士',
    'Sweden': '瑞典',
    'Norway': '挪威',
    'Denmark': '丹麦',
    'Finland': '芬兰',
    'Poland': '波兰',
    'Austria': '奥地利',
    'Turkey': '土耳其',
    'Egypt': '埃及',
    'South Africa': '南非',
    'United Arab Emirates': '阿联酋',
    'Thailand': '泰国',
    'Vietnam': '越南',
    'Malaysia': '马来西亚',
    'Indonesia': '印度尼西亚',
    'Philippines': '菲律宾',
    'New Zealand': '新西兰',
    'Chile': '智利',
    'Portugal': '葡萄牙',
    'Greece': '希腊',
    'Belgium': '比利时',
    'Ireland': '爱尔兰',
    'Czech Republic': '捷克',
    'Hungary': '匈牙利',
    'Romania': '罗马尼亚',
    'Ukraine': '乌克兰',
    'Israel': '以色列',
    'Saudi Arabia': '沙特阿拉伯',
    'Pakistan': '巴基斯坦',
    'Bangladesh': '孟加拉国',
    'Iran': '伊朗',
    'Iraq': '伊拉克',
    'Nigeria': '尼日利亚',
    'Kenya': '肯尼亚',
    'Algeria': '阿尔及利亚',
    'Morocco': '摩洛哥',
    'Colombia': '哥伦比亚',
    'Peru': '秘鲁',
    'Venezuela': '委内瑞拉',
    'Ecuador': '厄瓜多尔',
    'Cuba': '古巴',
    'Dominican Republic': '多米尼加',
    'Puerto Rico': '波多黎各',
    'Jamaica': '牙买加',
    'Costa Rica': '哥斯达黎加',
    'Panama': '巴拿马',
    'Guatemala': '危地马拉',
    'Uruguay': '乌拉圭',
    'Paraguay': '巴拉圭',
    'Bolivia': '玻利维亚',
    'Honduras': '洪都拉斯',
    'El Salvador': '萨尔瓦多',
    'Nicaragua': '尼加拉瓜',
    'Iceland': '冰岛',
    'Luxembourg': '卢森堡',
    'Slovakia': '斯洛伐克',
    'Slovenia': '斯洛文尼亚',
    'Croatia': '克罗地亚',
    'Serbia': '塞尔维亚',
    'Bulgaria': '保加利亚',
    'Lithuania': '立陶宛',
    'Latvia': '拉脱维亚',
    'Estonia': '爱沙尼亚',
    'Belarus': '白俄罗斯',
    'Myanmar': '缅甸',
    'Cambodia': '柬埔寨',
    'Laos': '老挝',
    'Mongolia': '蒙古',
    'Nepal': '尼泊尔',
    'Sri Lanka': '斯里兰卡',
    'Afghanistan': '阿富汗',
    'Kazakhstan': '哈萨克斯坦',
    'Uzbekistan': '乌兹别克斯坦',
    'Georgia': '格鲁吉亚',
    'Armenia': '亚美尼亚',
    'Azerbaijan': '阿塞拜疆',
    'Qatar': '卡塔尔',
    'Kuwait': '科威特',
    'Bahrain': '巴林',
    'Oman': '阿曼',
    'Jordan': '约旦',
    'Lebanon': '黎巴嫩',
    'Brunei': '文莱',
    'Timor-Leste': '东帝汶',
    'Maldives': '马尔代夫',
    'Bhutan': '不丹',
    'Fiji': '斐济',
    'Papua New Guinea': '巴布亚新几内亚'
  };
  return countryNameMap[countryNameEn] || countryNameEn;
};

// URL友好的国家名称转换
export const countryNameToUrlSlug = (countryName: string): string => {
  return countryName
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '')
    .trim();
};

// 根据国家代码获取国家信息
export const getCountryByCode = (countryCode: string): CountryInfo | null => {
  const cities = popularCitiesByCountry[countryCode.toUpperCase()];
  if (!cities || cities.length === 0) return null;

  const firstCity = cities[0];
  return {
    countryCode: countryCode.toUpperCase(),
    countryName: firstCity.country,
    countryNameZh: getCountryNameZh(firstCity.country),
    flag: firstCity.flag,
    citiesCount: cities.length
  };
};

// 从URL slug获取国家信息（通过匹配国家名称）
export const getCountryByNameSlug = (slug: string): CountryInfo | null => {
  // 遍历所有国家，找到匹配的
  for (const [countryCode, cities] of Object.entries(popularCitiesByCountry)) {
    if (cities.length > 0) {
      const firstCity = cities[0];
      const countryNameSlug = countryNameToUrlSlug(firstCity.country);
      const countryNameZhSlug = countryNameToUrlSlug(getCountryNameZh(firstCity.country));

      // 直接比较slug，不做转换
      if (countryNameSlug === slug || countryNameZhSlug === slug) {
        return {
          countryCode: countryCode.toUpperCase(),
          countryName: firstCity.country,
          countryNameZh: getCountryNameZh(firstCity.country),
          flag: firstCity.flag,
          citiesCount: cities.length
        };
      }
    }
  }

  return null;
};